import api from "../../../lib/api";

export default {
  getHybridViewerReaderLaunchUrl(data) {
    return api({
      endpoint: "hybrid-viewer-reader-launch-url",
      path: "walls",
      method: "GET",
      queryParams: data
    });
  },
  postSecretWord(data) {
    return api({
      endpoint: "bookshelf-reading-authorizations",
      path: "walls",
      method: "POST",
      body: data
    });
  },
  postRatingAgreements(data) {
    return api({
      endpoint: "bookshelf-rating-agreements",
      path: "walls",
      method: "POST",
      body: data
    });
  }
};
